export default {
    page(state) {
        return state.page
    }
}